export const convertNumToMoney = ({ num, culture = null }) => {
  if (num) {
    return num.toFixed(2) + "₪";
  } else {
    return null;
  }
};
